import { Pipe, PipeTransform } from '@angular/core'
import { DatePipe } from '@angular/common'

@Pipe({
    name: 'relativeTime',
})
export class RelativeTimePipe implements PipeTransform {

    transform(date: Date | null, minutesAgo?: number): string | null {
        if (minutesAgo !== undefined) {
            if (minutesAgo < 1) {
                return 'Just now'
            }
            if (minutesAgo === 1) {
                return '1 minute ago'
            }
            if (minutesAgo < 60) {
                return `${minutesAgo} minutes ago`
            }
            const diffInHours = Math.floor(minutesAgo / 60)
            if (diffInHours === 1) {
                return '1 hour ago'
            }
            if (diffInHours < 24) {
                return `${diffInHours} hours ago`
            }
            const diffInDays = Math.floor(diffInHours / 24)
            if (diffInDays === 1) {
                return '1 day ago'
            }
            return `${diffInDays} days ago`
        }
        if (!date) {
            return null
        }
        const now = new Date()
        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000)
        const diffInMinutes = Math.floor(diffInSeconds / 60)
        if (diffInMinutes < 1) {
            return 'Just now'
        }
        if (diffInMinutes === 1) {
            return '1 minute ago'
        }
        if (diffInMinutes < 60) {
            return `${diffInMinutes} minutes ago`
        }
        const diffInHours = Math.floor(diffInMinutes / 60)
        if (diffInHours === 1) {
            return '1 hour ago'
        }
        if (diffInHours < 24) {
            return `${diffInHours} hours ago`
        }
        const diffInDays = Math.floor(diffInHours / 24)
        if (diffInDays === 1) {
            return '1 day ago'
        }
        return `${diffInDays} days ago`
    }
}
